import React, { forwardRef } from 'react'
import styled from '@emotion/styled'
import { Types } from '../../../tw/types'
import DownloadButton from './Buttons/DownloadButton'
import PreviewButton from './Buttons/PreviewButton'
import LinkButton from './Buttons/LinkButton'
import VideoButton from './Buttons/VideoButton'
import AudioButton from './Buttons/AudioButton'
import ViewButton from './Buttons/ViewButton'
import { references } from '../../../state/state'
import { getRecoil } from '../../../state/recoilNexus'
import { Objects } from '../../../utils/objects'

const Wrapper = styled.div`
	display: flex;

	button {
		min-width: 38px;
		width: 38px;
		height: 38px;
		padding: 0;

		svg {
			height: 24px;
			width: 24px;
		}
	}
`

type CardActionsProps = {
	item: any
	downloadIcon?: React.ReactNode
	previewIcon?: React.ReactNode
	linkIcon?: React.ReactNode
	courseIcon?: React.ReactNode
}

const CardActions = forwardRef<HTMLButtonElement, CardActionsProps>(
	({ item, downloadIcon, previewIcon, linkIcon, courseIcon }, ref) => {
		const renderActionButton = () => {
			const optionalButtons: JSX.Element[] = []

			const renderOptionalButtons = () => {
				return optionalButtons.length > 0 ? <>{optionalButtons}</> : <></>
			}

			switch (item.getType()) {
				case Types.DOCUMENT:
				case Types.IMAGE:
					if (item.hasPreview()) {
						optionalButtons.push(
							<PreviewButton
								ref={ref}
								key={`preview-${item.uid}`}
								icon={previewIcon}
								item={item}
							/>
						)
					}
					if (item.downloadable()) {
						optionalButtons.push(
							<DownloadButton
								key={`download-${item.uid}`}
								icon={downloadIcon}
								item={item}
							/>
						)
					}
					return renderOptionalButtons()
				case Types.LINK:
				case Types.USEFUL_LINK:
					return (
						<LinkButton icon={linkIcon} courseIcon={courseIcon} item={item} />
					)
				case Types.VIDEO:
					return (
						<VideoButton
							item={item}
							onClick={item.defaultAction().actionHandler}
						/>
					)
				case Types.AUDIO:
					const isZip = Objects.default(getRecoil(references(item.file)), {
						isZIP: () => false
					}).isZIP()

					if (!isZip) {
						optionalButtons.push(
							<AudioButton ref={ref} key={`audio-${item.uid}`} item={item} />
						)
					}
					if (item.downloadable()) {
						optionalButtons.push(
							<DownloadButton
								key={`download-${item.uid}`}
								icon={downloadIcon}
								item={item}
							/>
						)
					}
					return renderOptionalButtons()
				case Types.SUBJECT_UPDATES:
					return <ViewButton item={item} />
			}
		}

		return (
			<Wrapper className="card-actions" data-testid="card-actions">
				{renderActionButton()}
			</Wrapper>
		)
	}
)

export default CardActions
